import React from 'react';
import { Input, Row, Typography, Spin } from 'antd';

import colors from '../../styles/colors';

import * as S from './styles';

const { TextArea } = Input;
const { Text } = Typography;

export function ModalAttendance({
  title,
  visible,
  okBtn,
  cancelBtn,
  textBtnOk,
  textBtnCancel,
  explain = false,
  titleExplain,
  disabled,
  loadingModal = false,
  changeText = () => '',
  subTitle,
}) {
  return (
    <S.ModalContent
      open={visible}
      footer={null}
      maskClosable={false}
      centered
      closable={false}
      okButtonProps={{}}
      onOk={okBtn}
    >
      <S.ContenModal>
        <S.Title>{title || ''}</S.Title>
        <Spin
          spinning={loadingModal}
          size="large"
          style={{
            position: 'fixed',
            zIndex: 999,
          }}
          tip="Carregando..."
        />
        {subTitle && (
          <Row justify="center">
            <Text
              style={{
                paddingTop: 10,
                fontSize: 14,
                color: colors.greyText,
              }}
            >
              {subTitle || ''}
            </Text>
          </Row>
        )}
        <S.ContainerButtons>
          <S.ButtonCustom
            disabled={loadingModal}
            onClick={cancelBtn}
            type="secundary"
            size="large"
            style={{
              background: colors.branco,
              border: `solid 1px ${colors.verde}`,
              color: colors.verde,
            }}
          >
            {textBtnOk || 'NÃO'}
          </S.ButtonCustom>
          <S.ButtonCustom
            disabled={disabled || loadingModal}
            onClick={okBtn}
            type="primary"
            size="large"
            style={{
              color: disabled ? colors.lightGrey : colors.branco,
              background: disabled ? colors.gbGrey : colors.verde,
              border: `solid 1px ${disabled ? colors.gbGrey : colors.verde}`,
            }}
          >
            {textBtnCancel || 'SIM'}
          </S.ButtonCustom>
        </S.ContainerButtons>
        {explain && (
          <S.ContainerInput>
            <Row justify="center">
              <Text
                style={{
                  fontSize: 12,
                  color: colors.greyText,
                }}
              >
                {titleExplain || ''}
              </Text>
            </Row>
            <TextArea
              id="textArea"
              autoFocus
              disabled={loadingModal}
              autoSize={{ minRows: 4, maxRows: 4 }}
              placeholder="Digite aqui"
              onChange={changeText}
            />
          </S.ContainerInput>
        )}
      </S.ContenModal>
    </S.ModalContent>
  );
}
